export enum Actions {
  AttendeeOpened = 'attendee_click',
  BurgerIconClick = 'burger_icon_click',
  ButtonClick = 'button_click',
  ButtonClickFilter = 'button_click_filter',
  CTAButtonClick = 'cta_button_click',
  FormFirstInteractionClick = 'first_form_interaction_click',
  FormInteractionClick = 'form_interaction_click',
  FormSubmit = 'form_submit_click',
  MenuItemClick = 'menu_item_click',
  Submit = 'submit',
  TabClick = 'tab_click',
  TimeslotOpened = 'timeslot_opened',
  TitoButtonPress = 'tito_button_press',
  TooltipHover = 'tooltip_hover',
}

export enum Categories {
  Attendee = 'Attendee',
  Checkout = 'Checkout',
  CivicCookie = 'Civic Cookie',
  FooterMenu = 'Footer menu',
  Form = 'Form',
  HeaderMenu = 'Header menu',
  Schedule = 'Schedule',
  Tickets = 'Tickets',
}

export enum Labels {
  Close = 'Close',
  Open = 'Open',
}
